import { Button, CheckboxCard, CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { SimpleDialog } from '../../../Dialog/SimpleDialog';
import { DetailsAddress } from '../types';
import {
  formatAddressLocality,
  formatAddressName,
  formatAddressStreet,
} from '../utils/format';
import { AddNewRow } from './AddNewRow';

export type SelectAddressDialogProps = {
  addresses: DetailsAddress[];
  selectedAddressId?: string;
  onSave: (addressId: string) => void;
  onAddNew: () => void;
  onClose: () => void;
};

export const SelectAddressDialog = ({
  addresses,
  onAddNew,
  onClose,
  onSave,
  selectedAddressId,
}: SelectAddressDialogProps) => {
  const { t } = useTranslation('checkout');
  const [draftId, setDraftId] = useState(selectedAddressId);

  return (
    <SimpleDialog
      centered
      onClose={onClose}
      open
      title={t('details.shippingAddress.selectTitle')}
    >
      <div className="flex flex-col gap-3 pt-1">
        <CheckboxWrapper hideLabel>
          {addresses.map((address) => (
            <CheckboxCard
              key={address.id}
              checked={draftId === address.id}
              features={[
                formatAddressStreet(address),
                formatAddressLocality(address),
              ]}
              id={`details-address-${address.id}`}
              label={formatAddressName(address)}
              name="details-address"
              onChange={() => setDraftId(address.id)}
              type="radio"
              value={address.id}
            />
          ))}
        </CheckboxWrapper>

        <AddNewRow
          label={t('details.shippingAddress.addNew')}
          onClick={onAddNew}
        />

        <Button
          disabled={!draftId}
          fullWidth
          label={t('details.save')}
          onClick={() => draftId && onSave(draftId)}
          variant="primary"
        />
      </div>
    </SimpleDialog>
  );
};
